import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendDeleteCustomerOnboardingEmailPayload,
  BackendMutationDeleteCustomerOnboardingEmailArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteCustomerOnboardingEmail($customerId: ID!) {
    deleteCustomerOnboardingEmail(customerId: $customerId) {
      success
    }
  }
`;

type Variables = BackendMutationDeleteCustomerOnboardingEmailArgs;
type Result = BackendDeleteCustomerOnboardingEmailPayload;

export const deleteCustomerOnboardingEmail = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
